import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { IonInput } from '@ionic/angular/standalone';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';

@Component({
  selector: 'fv-numericintegerinput',
  templateUrl: './numericintegerinput.component.html',
  styleUrls: ['./numericintegerinput.component.scss'],
  imports: [
    IonicComponentsModule
  ],
  standalone: true,
})
export class NumericintegerinputComponent  implements ControlValueAccessor {

 //#region Propiedades

 private _value: string
 public get value(): string {
   return this._value
 }
 @ViewChild("input") public input: IonInput
 @ViewChild("inputSimple") public inputSimple: ElementRef<HTMLInputElement>
 @Input("value") public set value(val: string) {
   this._value = val
 }
 @Output("valueChange") public valueChange = new EventEmitter<{newValue: string, oldValue: string}>()
 @Input("label") public label: string
 @Input("placeholder") public placeholder: string
 @Input("simple") public simple: boolean = false
 @Input("readonly") public readonly: boolean = false
 @Input("obligatorio") public obligatorio: boolean // Esto es solo para pintar un asterisco, y este campo no se lee de los validadores, sino que hay que establecerlo a mano.

 //#endregion

 //#region Constructor
 
 constructor(
  @Self() @Optional() private control: NgControl
 ) { 
  this.control.valueAccessor = this
 }

 //#endregion

 //#region Eventos

 public onTextChange(): void {
    let currentValue: string
    if (this.simple) {
      currentValue = this.inputSimple.nativeElement.value.toString()
    } else {
      currentValue = this.input.value.toString()
    }
    if (this._value != currentValue) {
      let oldValue = this._value
      this.value = currentValue
      this.onChange(this.value)
      this.valueChange.emit({newValue: this.value, oldValue: oldValue})
    }
    this.onTouched()
  }

  public blur(): void {
    this.onTouched()
  }

 //#endregion

 //#region Reactive Forms

 private onChange = (value: string) => {}
 private onTouched = () => {}

 writeValue(value: string): void {
   let oldValue = this._value
   this.value = value
   this.valueChange.emit({newValue: value, oldValue: oldValue})
   this.onChange(value)
 }

 registerOnChange(fn: (value: string) => {}): void {
   this.onChange = fn
 }

 registerOnTouched(fn: () => {}): void {
   this.onTouched = fn
 }

 public isInvalid(): boolean {
  return this.control ? this.control.invalid : false;
 }

 //#endregion

}
